import React, { FC, ReactChild } from "react";

import styled from "@emotion/styled";

export const List = styled.div`
    margin: 0 -1.25rem;
`;
